import React from 'react';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import InsightsIcon from '@mui/icons-material/Insights';
import parse from 'html-react-parser';
import { useNavigate } from 'react-router';
import { ObjectMap } from 'mf_core/config';
import { getFormattedNumber } from '../../utils/common.util';

type InsightPropTypes = {
  additionalInsightsData?: ObjectMap;
  bodyContent: string | null;
  ctaLink?: string;
  currentPage?: string;
  dataName?: string;
  insightTitle: string | null;
};

export const StyledInsightsWrapper = (props: InsightPropTypes) => {
  const {
    additionalInsightsData,
    bodyContent,
    ctaLink,
    currentPage,
    dataName,
    insightTitle,
  } = props;
  const navigate = useNavigate();

  return (
    <StyledInsightDetailsStackWrapper direction="row" spacing={1}>
      <Stack direction="column" spacing={1}>
        <Stack direction="row" spacing={1}>
          <InsightsIcon />
          <Typography variant="bodycopysemibold">{insightTitle}</Typography>
        </Stack>

        {ctaLink ? (
          <StyledStack direction="row" spacing={1}>
            <Typography
              data-name={dataName}
              onClick={() => navigate(ctaLink ?? '')}
              sx={{ cursor: 'pointer' }}
              variant="bodycopyregular"
            >
              {currentPage === 'Renewals Page'
                ? parse(
                    `<div class='insight-content data-name=${dataName}'>${parse(
                      bodyContent ?? ''
                    )}<span style="font-weight:bold">${getFormattedNumber(
                      additionalInsightsData?.['renewal revenue'] ?? ''
                    )}</span> </div>`
                  )
                : parse(
                    `<div class='insight-content'>${parse(
                      bodyContent ?? ''
                    )}</div>`
                  )}
            </Typography>
          </StyledStack>
        ) : (
          <StyledStack direction="row" spacing={1}>
            <Typography variant="bodycopyregular">
              {parse(
                `<div class='insight-content'>${parse(bodyContent ?? '')}</div>`
              )}
            </Typography>
          </StyledStack>
        )}
      </Stack>
    </StyledInsightDetailsStackWrapper>
  );
};

const StyledStack = styled(Stack)(() => ({
  '& .insight-content': {
    a: {
      '&:hover, &:link, &:active, &:visited': { color: '#0077D4 !important' },
      color: '#0077D4',
      fontWeight: 600,
      textDecoration: 'none',
    },
    fontSize: '14px',
  },
}));

const StyledInsightDetailsStackWrapper = styled(Stack)(({ theme }) => ({
  '&: hover': {
    background: '#f4f4f4',
  },
  borderBottom: '1px solid #ececec',
  flexGrow: 1,
  maxWidth: 650,
  padding: theme.spacing(1),
  paddingBottom: theme.spacing(2),
}));
